export const FILE_IDS = ['fileIds'];
export const FILE_USAGE_TYPES = ['fileUsageTypes'];